import { makeAutoObservable, runInAction } from 'mobx'
import { addManager, Auth, loadAuth, loadManagers, Me, removeManager, saveAuth, User } from 'type/auth'
import { saveClient } from 'type/client'
import { fetchJson } from 'util/fetch'
import { matchSearch } from 'util/search'

export class EmployeeStore {
  private _auth: Auth | null = null
  user: User | null = null
  private all: Me[] = []
  private _search: string = ''

  constructor() {
    makeAutoObservable(this)
  }

  get manager_id(): string | undefined {
    return this.user?.user_id || undefined
  }

  get auth(): Auth | null {
    return this._auth
  }

  set auth(auth: Auth | null) {
    this._auth = auth
    saveAuth(auth ?? undefined)
  }

  preload() {
    this.auth = loadAuth() || null
    this.all = loadManagers() || []
    if (this.auth) {
      const employee = this.all.find(e => e.auth && this.auth && e.auth.id_token === this.auth.id_token)
      if (employee) this.user = employee.user
      else this.auth = null
    }
  }

  logout() {
    this.auth = null
    this.user = null
  }

  get employees(): Me[] {
    return this.all.filter(employee => matchSearch(this.search, [employee.user.name, employee.user.email]))
  }

  get search(): string {
    return this._search
  }

  set search(value: string) {
    this._search = value
  }

  remove(user_id: string) {
    removeManager(user_id)
    saveClient(user_id, undefined)
    this.all = loadManagers() || []
  }

  async load(company: string) {
    try {
      if (!this.auth) return
      const { id_token, refresh_token } = this.auth
      const request = JSON.stringify({ id_token, refresh_token, company })
      const response = await fetchJson<Me>('/api/boutique/me', { method: 'POST', body: request })
      let { auth, user } = response
      if (!auth) auth = this.auth
      runInAction(() => {
        this.auth = auth
        this.user = user
        addManager({ auth, user })
        this.all = loadManagers() || []
      })
    } catch (e) {
      console.error('auth failed', e)
      runInAction(() => this.auth = null)
    }
  }
}

export const employee = new EmployeeStore()
